import { isRouteErrorResponse, useRouteError } from '@remix-run/react';
import { captureRemixErrorBoundaryError } from '@sentry/remix';

import { OnboardingLayout } from '@shieldpay/bumblebee/layouts/onboarding';
import { Text } from '@shieldpay/bumblebee/text';

import { ShieldpayLogo } from '@shieldpay/utilities-ui/shieldpay-logo';

import { Error } from '~/components/error/error';

export const ProdErrorBoundary = () => {
  const error = useRouteError();

  captureRemixErrorBoundaryError(error);

  return (
    <OnboardingLayout header={<ShieldpayLogo />} footer={<></>}>
      {isRouteErrorResponse(error) ? (
        <Error>
          <Error.Heading>{error.status} error</Error.Heading>
          <Text>{error.statusText}</Text>
        </Error>
      ) : (
        <Error>
          <Error.Heading>Sorry there has been an error</Error.Heading>
          {error instanceof Object && 'statusText' in error ? (
            <Text>{String(error.statusText)}</Text>
          ) : null}
        </Error>
      )}
    </OnboardingLayout>
  );
};
